// extracted by mini-css-extract-plugin
export default {"SetPasswordForm":"SetPassword_SetPasswordForm__RsAOE","SubmitButton":"SetPassword_SubmitButton__EoliV","ErrorMessage":"SetPassword_ErrorMessage__C41SP"};